import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// import './index.css'
// import App from './App.tsx'

// createRoot(document.getElementById('root')!).render(
//   <StrictMode>
//     <App />
//   </StrictMode>,
// )

import { RouterProvider, createRouter } from '@tanstack/react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { routeTree } from './routeTree.gen'
import { AuthProvider } from './lib/auth'
import { initTheme } from './lib/theme'
import './index.css'

initTheme()

import { Toaster } from '@/components/ui/sonner'

const queryClient = new QueryClient()

const router = createRouter({
  routeTree,
  stringifySearch: (search) => {
    const qs = new URLSearchParams(
      Object.entries(search)
        .filter(([, v]) => v !== undefined && v !== null)
        .map(([k, v]) => [k, String(v)])
    ).toString().replaceAll('%2C', ',')
    return qs ? `?${qs}` : ''
  },
  parseSearch: (searchStr) =>
    Object.fromEntries(new URLSearchParams(searchStr).entries()),
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster position="bottom-right" />
      </QueryClientProvider>
    </AuthProvider>
  </StrictMode>
)